export const partners = [
  {
    id: "thermofisher",
    logo: "https://res.cloudinary.com/dhbe6wtod/image/upload/v1714112731/healix/partners/thermo-fisher-scientific-logo-5279x1344_nsx5ln.png",
    alt: "Thermo Fisher Scientific logo - Quality Controls partner",
    caption: "Quality Controls",
    link: "https://www.thermofisher.com/mw/en/home.html",
  },
  {
    id: "Hologic",
    logo: "https://res.cloudinary.com/dhbe6wtod/image/upload/v1714112734/healix/partners/Hologic_zczdtx.png",
    alt: "Hologic logo - Molecular Diagnostics partner",
    caption: "Molecular Diagnostics",
    link: "https://www.hologic.com/molecular-diagnostics",
  },
  {
    id: "beckmancoulter",
    logo: "https://res.cloudinary.com/dhbe6wtod/image/upload/v1714112730/healix/partners/beckmn_kusac5.png",
    alt: "Beckman Coulter logo - Clinical Diagnostics partner",
    caption: "Clinical Diagnostics",
    link: "https://www.beckmancoulter.com/",
  },
  {
    id: "beckman",
    logo: "https://res.cloudinary.com/dhbe6wtod/image/upload/v1748271104/healix/partners/blt_j52fqc.svg",
    alt: "Beckman logo - Life Sciences partner",
    caption: "Life Sciences",
    link: "https://www.beckman.com/about-us",
  },
  {
    id: "elga",
    logo: "https://res.cloudinary.com/dhbe6wtod/image/upload/v1714119743/healix/partners/elga-labwater-2.png",
    alt: "ELGA LabWater logo - Water Purification partner",
    caption: "Water Purification",
    link: "https://www.anz.veoliawatertechnologies.com/solutions/services/elga-ultrapure-laboratory-water",
  },
  {
    id: "radiometer",
    logo: "https://res.cloudinary.com/dhbe6wtod/image/upload/v1714119456/healix/partners/radiometer-medical-2.png",
    alt: "Radiometer Medical logo - Blood gas testing partner",
    caption: "Blood gas",
    link: "https://www.radiometer.com/en/products/blood-gas-testing",
  },
];
